import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateBR } from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import { useAuth } from "../../../../hooks/AuthenticateContext";
import api from "../../../../services/api";
import Create from "./Create";
import Info from "./Info";
import { ITipoCargaSPE } from "./types/types";
import ModalHistory from "../../../../components/ModalHistory";
import Can from "../../../../components/Can";

const TipoCargaSPE: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "id_tipo_carga_SPE",
      headerName: "ID",
      filter: true,
      flex: 1,
    },
    {
      field: "tipo_carga",
      headerName: "Tipo de Carga",
      filter: true,
      flex: 2,
      valueFormatter: (params: ValueFormatterParams) => params.value || "---",
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => params.value || "---",
    },
    {
      field: "data_historico",
      headerName: "Data Modificação",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateBR(params.value);
        }
        return "---";
      },
    },
  ]);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<ITipoCargaSPE>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);

  const { isModalOpen, openModal, closeModal } = useModal();
  const { user } = useAuth();
  const gridRef = useRef<any>();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_tipo_carga_SPE: rowId,
        id_usuario_historico: user?.id,
      };

      await api.post("/deletar/tipoCargaSpe", body);
      setLoading(false);
      setIsRemove(false);
      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, [user]);

  return (
    <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
      <Loading loading={loading} />
      {isModalOpen && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(false)}
          onConfirm={() => onDelete(selectedRow?.id_tipo_carga_SPE)}
          row={selectedRow?.tipo_carga || String(selectedRow?.id_tipo_carga_SPE)}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Detalhes - Tipo de Carga SPE"
          onClose={() => setIsView(false)}
        />
      )}

      {isHistory && selectedRow && (
        <ModalHistory
          isOpen={isHistory}
          title="Histórico - Tipo de Carga SPE"
          historyRoute="/historico/tipoCargaSpe"
          bodyKey="id_tipo_carga_SPE"
          bodyValue={selectedRow.id_tipo_carga_SPE ?? 0}
          onClose={() => setIsHistory(false)}
        />
      )}

      <div className="flex items-center justify-between w-full mb-3">
        <div>
          <h1 className="text-2xl text-[#000000] font-bold">Tipos de Carga SPE</h1>
        </div>
        <div className="mr-14 flex items-center gap-4">
          <Can acao="SALVAR">
          <button
            className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
            onClick={() => {
              setSelectedRow(undefined);
              setIsEdit(false);
              setIsView(false);
              openModal();
            }}
            id="btnCreateTipoCargaSPE"
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
          </Can>
        </div>
      </div>
      <div className="flex w-full">
        <Grid
          ref={gridRef}
          columns={columns}
          filters={[]}
          status={[]}
          pagination
          path="/listar/tipoCargaSpe"
          onDelete={(data: any) => {
            setIsRemove(true);
            setSelectedRow(data);
          }}
          isShowStatus={false}
          onView={(data: any) => {
            setSelectedRow(data);
            setIsView(true);
          }}
          onUpdate={(data: any) => {
            setSelectedRow(data);
            setIsEdit(true);
            setIsView(false);
            openModal();
          }}
          onHistory={(data: any) => {
            setSelectedRow(data);
            setIsHistory(true);
          }}
        />
      </div>
    </div>
  );
};

export default TipoCargaSPE;
